import { createSite } from 'api/site';
import { useMutation, useQueryClient } from 'react-query';
import { errorToast } from 'utils/errorToast';
import { successToast } from 'utils/successToast';

export const useCreateSite = (washHub: string, onSuccess?: () => void) => {
  const queryClient = useQueryClient();

  const { mutate, isLoading, error } = useMutation(createSite, {
    onSuccess: () => {
      successToast('Site Created Successfully');

      queryClient.invalidateQueries(`fetch-sites-${washHub}`);
      queryClient.invalidateQueries(`fetch-sites-all-${washHub}`);
      queryClient.invalidateQueries(`fetch-sites-active-${washHub}`);

      queryClient.invalidateQueries(`fetch-sites-${washHub}-select`, {
        exact: true,
      });
      queryClient.invalidateQueries(`fetch-sites-active-${washHub}-select`, {
        exact: true,
      });

      queryClient.invalidateQueries('fetch-sites-select-all', { exact: true });
      queryClient.invalidateQueries('fetch-sites-active-select-all', {
        exact: true,
      });

      queryClient.invalidateQueries(['fetch-sites-active']);

      queryClient.invalidateQueries(['fetch-skus-for-packages']);

      onSuccess?.();
    },
    onError: () => {
      errorToast('Something went wrong, please try again!');
    },
  });

  const onCreateSite = (sanitizedPayload: any | null) =>
    mutate(sanitizedPayload);

  return { onCreateSite, isCreateLoading: isLoading, createError: error };
};
